// extracted by mini-css-extract-plugin
export default {"symbol":"escalation-icon_symbol__TSD5M"};